import { MaterialService } from './material.service';
import { Corporate, CorporateList } from '../model/corporate.model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';

@Injectable()
export class CorporateService extends KiwixiService {
    apiCorporate = environment.server + 'corporates/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    /**
     * Récupère la liste des corporates avec filtres (pagination, tri, recherche)
     */
    getCorporates(params: HttpParams): Observable<CorporateList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<CorporateList>(this.apiCorporate, {
            headers: header,
            params: params,
        }).
            pipe(
                catchError(this.handleErrorObservable<CorporateList>(`getCorporates`))
            );
    }

    /**
     * Récupère la liste des corporates avec objet params (compatible avec BusinessService)
     */
    get(params: any): Observable<CorporateList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<CorporateList>(this.apiCorporate, {
            params: params,
            headers: header
        }).pipe(
            catchError(this.handleErrorObservable<CorporateList>('getCorporatesWithParams'))
        );
    }

    /**
     * Récupère un corporate par ID
     */
    getOne(id: number | string, salt = false): Observable<Corporate> {
        const header = this.createHttpClientAuthorizationHeader();
        let url = this.apiCorporate + id + '/';
        if (salt) {
            url += '?salt=' + Math.random();
        }
        return this._http.get<Corporate>(url, {
            headers: header
        }).pipe(
            catchError(this.handleErrorObservable<Corporate>('getCorporateById'))
        );
    }

    getCorporateWithUrl(_url): Observable<Corporate[]> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<Corporate[]>(_url, {
            headers: header
        }).
            pipe(
                catchError(this.handleErrorObservable<Corporate[]>(`getCorporateWithUrl`))
            );
    }

    /**
     * Crée un nouveau corporate
     */
    post(data: any): Observable<Corporate> {
        const header = this.createHttpClientAuthorizationHeaderNoEnctype();
        return this._http.post<Corporate>(this.apiCorporate, data, { headers: header }).pipe(
            catchError(this.handleErrorObservable<Corporate>('postCorporate'))
        );
    }

    /**
     * Met à jour un corporate
     */
    patch(data: any, id: number | string): Observable<Corporate> {
        const header = this.createHttpClientAuthorizationHeaderNoEnctype();
        return this._http.patch<Corporate>(this.apiCorporate + id + '/', data, { headers: header }).pipe(
            catchError(this.handleErrorObservable<Corporate>('patchCorporate'))
        );
    }

    /**
     * Supprime un corporate
     */
    delete(id: number | string): Observable<any> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.delete(this.apiCorporate + id + '/', { headers: header }).pipe(
            catchError(this.handleErrorObservable<any>('deleteCorporate'))
        );
    }
}


